// 料金のフォーマットを行う関数
// 数値または文字列を受け取り、カンマ区切りの文字列に変換する
// 例: 4000 -> "4,000", "4000" -> "4,000"
const formatPrice = (price) => {
    const num = typeof price === 'number' ? price : Number(price);
    if (isNaN(num))
        return String(price);
    return num.toLocaleString();
};
export default formatPrice;
